// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "client_package".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { clientPackageSourceValues, clientPackageStatusValues } from '@borradh-workspace/labels';
/** Response atom for the "client_package" table (1:1 with a DB row, on the wire). */
export const clientPackageAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    leadId: z.string(),
    packageId: z.string().nullable(),
    name: z.string(),
    status: z.enum(clientPackageStatusValues),
    source: z.enum(clientPackageSourceValues),
    listPriceCents: z.number(),
    priceCents: z.number(),
    currency: z.string(),
    offerId: z.string().nullable(),
    offerRedemptionReleasedAt: z.string().datetime().nullable(),
    validityDays: z.number().nullable(),
    activatedAt: z.string().datetime().nullable(),
    expiresAt: z.string().datetime().nullable(),
    cancelledAt: z.string().datetime().nullable(),
    originAppointmentId: z.string().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=clientPackage.js.map